<template>

  <div class="container pt-4 pb-4">

    <div>

      <b-row align-v="center">

        <b-col lg="12">

          <div class="mt-4">

            <div class="mt-3">

              <label>
                <span class="material-symbols-outlined align-middle text-primary fw-200">
                  text_snippet
                </span> 
                Wybierz styl z listy:
              </label>

              <b-input-group>

                <b-form-select v-model="style" ref="style" size="lg" :options="styles"></b-form-select>

              </b-input-group>

 
              <label class="mt-3">
                <span class="material-symbols-outlined align-middle text-primary fw-200">
                  image
                </span> 
                Dodaj zdjęcie
              </label>

              <b-input-group>

                <b-form-file type="file" accept="image/*" @change="onFileChange" size="lg" ref="file" placeholder="Wybierz plik..." browse-text="Wybierz plik"></b-form-file>

              </b-input-group>
 
            </div>

          </div>

        </b-col>

      </b-row>

      <hr/>

      <b-row align-v="center" class="mt-2" style="min-height: 40px;">

        <b-col lg="6">

        </b-col>

        <b-col lg="6">

          <b-button variant="outline-success mr-1" ref="generatePost" @click="generateFinish()" class="mt-3 float-right">
          <span class="material-symbols-outlined align-middle">
            bolt
          </span>
            Generuj grafikę
          </b-button>

        </b-col>

      </b-row>

 
      <div class="mt-2" >

        <b-card header-tag="header" class="mt-4" v-if="isFinish">

          <template #header>

            <h6 class="mb-0 mt-2 float-left">
              <span v-if="!finishContent"><b-spinner variant='secondary' small></b-spinner> AI generuje grafikę <small>(może to potrwać dłuższą chwilę. Nie odświeżaj strony!)</small></span>
              <span v-if="finishContent">Proszę czekać...</span>
            </h6>

            <b-button class="float-right p-0" variant="outline-white" @click="isFinish = false">

              <span class="material-symbols-outlined mt-1">close</span>

            </b-button>

          </template>

          <blockquote class="blockquote mb-0" style="font-size: 1em;">

            <img ref="outputImg" style="width:100%;height:auto;" src="" />

          </blockquote>

        </b-card>

      </div>

    </div>

  </div>

</template>

<script>

export default {
  name: 'AppGraphicAi',
  components: {
  },
  data() {
    return {
      isFinish: false,
      result: "",
      generatedImg: false,
      imageBase64: null,
      imageBase64_2: null,
      selectedText: '',
      query: "",
      finishContent: '',
      selectedSchema: null,
      style: "Boho",
      styles: [
        "Boho",
        "Boho chic",
        "Boho minimalistyczne",
        "Styl wiktoriański",
        "Styl edwardiański",
        "Styl georgiański",
        "Styl grecki",
        "Styl grecki nowoczesny",
        "Styl śródziemnomorski",
        "Styl hiszpański",
        "Styl andaluzyjski",
        "Styl marokański",
        "Styl arabski",
        "Styl orientalny",
        "Styl japoński",
        "Styl japandi",
        "Styl zen",
        "Styl wabi-sabi",
        "Styl nowoczesny",
        "Styl ultranowoczesny",
        "Styl minimalistyczny",
        "Styl soft minimalism",
        "Styl skandynawski",
        "Styl skandynawski modern",
        "Styl nordic dark",
        "Styl industrialny",
        "Styl loftowy",
        "Styl postindustrialny",
        "Styl brutalistyczny",
        "Styl modern classic",
        "Styl klasyczny",
        "Styl klasyczny luksusowy",
        "Styl glamour",
        "Styl hollywood regency",
        "Styl art deco",
        "Styl art nouveau",
        "Styl retro",
        "Styl vintage",
        "Styl mid-century modern",
        "Styl lat 60.",
        "Styl lat 70.",
        "Styl eklektyczny",
        "Styl maximalistyczny",
        "Styl farmhouse",
        "Styl modern farmhouse",
        "Styl rustykalny",
        "Styl rustykalny europejski",
        "Styl rustykalny francuski",
        "Styl prowansalski",
        "Styl cottagecore",
        "Styl angielski cottage",
        "Styl shabby chic",
        "Styl country",
        "Styl coastal",
        "Styl hamptons",
        "Styl marynistyczny",
        "Styl tropikalny",
        "Styl balijski",
        "Styl hawajski",
        "Styl safari",
        "Styl kolonialny",
        "Styl kolonialny brytyjski",
        "Styl kolonialny hiszpański",
        "Styl afrykański",
        "Styl etniczny",
        "Styl tribal",
        "Styl meksykański",
        "Styl brazylijski",
        "Styl włoski klasyczny",
        "Styl toskański",
        "Styl francuski paryski",
        "Styl francuski modern",
        "Styl modern parisian",
        "Styl nowojorski",
        "Styl chic new york",
        "Styl high-end luxury",
        "Styl quiet luxury",
        "Styl japandi luxury",
        "Styl eco",
        "Styl biofiliczny",
        "Styl organic modern",
        "Styl earth tones",
        "Styl stone & wood",
        "Styl soft loft",
        "Styl dark academia",
        "Styl light academia",
        "Styl gothic",
        "Styl neo-gothic",
        "Styl fantasy",
        "Styl steampunk",
        "Styl cyberpunk",
        "Styl futuristic",
        "Styl sci-fi minimal",
        "Styl AI-generated surreal",
        "Styl concept art interior",
        "Styl hotelowy premium",
        "Styl spa & wellness",
        "Styl wellness zen",
        "Styl tiny house",
        "Styl smart home modern"
      ]
    }
  },
  methods: {

    onFileChange (event) {
      const file = event.target.files[0]
      if (!file) return

      const reader = new FileReader()

      reader.onload = (e) => {
        this.imageBase64 = e.target.result.split(',')[1]
        // albo jeśli chcesz tylko czysty base64:
        // this.imageBase64 = e.target.result.split(',')[1]
      }

      reader.readAsDataURL(file)
    },

    
    onFileChange2 (event) {
      const file = event.target.files[0]
      if (!file) return

      const reader = new FileReader()

      reader.onload = (e) => {
        this.imageBase64_2 = e.target.result.split(',')[1]
        // albo jeśli chcesz tylko czysty base64:
        // this.imageBase64 = e.target.result.split(',')[1]
      }

      reader.readAsDataURL(file)
    },

    generateFinish: function() {

      if(!this.style) return false;

      this.$refs.generatePost.disabled = true

      this.isFinish = true

      this.finishContent = ""
      this.result = ""
      
      var prompt = "Udekoruj to wnętrze w stylu " + this.style + "."
      
      this.axios.post(window.API_URL + "apps/graphicAi/paintnb/", { 'prompt': prompt, 'imageBase64': this.imageBase64  }, { withCredentials: true, timeout: 60000 }).then((response2) => {

          let data = response2.data

          this.finishContent = true;

          this.$refs.outputImg.src = "data:image/jpeg;charset=utf-8;base64," + data.base64;

          this.$refs.generatePost.disabled = false
          this.generatedPostTitle = "Wygenerowana grafika"


        }).catch(function() {

          this.$refs.generatePost.disabled = false

        });



    }

  },
  computed: {

  },
  created() {

    

  }

}
</script>

<style>

.pointer { cursor: pointer; }
.bold { font-weight: 600 !important; }
code { color: #4e82f7 !important; }
</style>